export function initVideoModal() {
    const modal = document.getElementById('videoModal');
    const iframe = document.getElementById('videoFrame');

    if(!modal || !iframe) return;

    document.querySelectorAll('.btn-play').forEach(btn => {
        btn.addEventListener('click', () => {
        iframe.src = btn.dataset.video;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        });
    });

    const closeModal = () => {
        iframe.src = '';
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
    };

    modal.querySelector('.video-backdrop').addEventListener('click', closeModal);
    modal.querySelector('.video-close').addEventListener('click', closeModal);
}